import { useEffect } from "react";
import { useForm, Form } from "../useForm";

import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";

const inputClassName =
  "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm";

const initialFValues = {
  name: "",
  location: "",
  start_date: "",
  end_date: "",
};

export default function CampaignDetailsForm(props) {
  const { campaign, actionCall, loading } = props;

  const { values, setValues, handleInputChange } = useForm(initialFValues, false);

  useEffect(() => {
    if (campaign) {
      setValues({
        name: campaign.name ?? "",
        location: campaign.location ?? "",
        start_date: campaign.start_date ?? "",
        end_date: campaign.end_date ?? "",
      });
    }
  }, [campaign, setValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    actionCall(campaign, values);
  };

  if (!campaign) {
    return null;
  }

  return (
    <Form
      classes="flex flex-col divide-y divide-gray-200 bg-white shadow-sm rounded-lg"
      onSubmit={handleSubmit}
    >
      <div className="px-4 py-6 sm:px-6">
        <div className="mt-2">
          <Input
            label="Name"
            name="name"
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            className={inputClassName}
          />
        </div>
        <div className="mt-2">
          <Input
            label="Location"
            name="location"
            onChange={handleInputChange}
            value={values.location}
            labelOn={true}
            type="text"
            className={inputClassName}
          />
        </div>
        <div className="mt-2">
          <DatePickerInput
            label="Start Date"
            name="start_date"
            onChange={handleInputChange}
            value={values.start_date}
            labelOn={true}
            type="text"
            dateFormat="LLL dd, yyyy"
            classes={inputClassName}
          />
        </div>
        <div className="mt-2">
          <DatePickerInput
            label="End Date"
            name="end_date"
            onChange={handleInputChange}
            value={values.end_date}
            labelOn={true}
            type="text"
            dateFormat="LLL dd, yyyy"
            classes={inputClassName}
          />
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
          >
            Save
          </button>
        </div>
      </div>
    </Form>
  );
}
